import React from 'react';
import { TabPanel } from '../TabPanel';

export interface IRouteTabProps {
  label: string;
  uri?: string;
  onClose?: () => void;
  children?: any;

  value?: string; // will be injected in RadishTabs Component.
  index?: string; // will be injected in RadishTabs Component.
  activeRender?: boolean;
}

const FixedTab = (props: IRouteTabProps): JSX.Element => {
  const { value, index } = props;

  return (
    <TabPanel value={value} index={index}>
      {(value === index || !props.activeRender) && props.children}
    </TabPanel>
  );
};

FixedTab.displayName = 'FixedTab';

export default React.memo(FixedTab);
